export default __webpack_public_path__ + "static/media/WhiteRemoveSchedule.49a0cb7b.svg";